import React, { useEffect, useState } from 'react';
import { Modal } from './ui/Modal';
import { Trash2, ArrowRight } from './ui/Icons';
import { useDashboard } from '../lib/DashboardContext';
import { loadPresets, savePresets, deletePreset as deletePresetForAccount, CategoryPreset } from '../lib/presets';

type TicketCategory = {
  name: string;
  price: number;
  capacity: number | '';
  description?: string;
  startOffset: number | '';
  startUnit: 'days' | 'hours';
  startBefore: boolean;
  // existing model: untilStart | after
  endType: 'untilStart' | 'after';
  endOffset: number | '';
  endUnit: 'hours';
  // UI helper: whether tickets are available until event end (visual toggle)
  saleUntilEnd?: boolean;
};

// CategoryPreset type is imported from lib/presets

const emptyCat = (): TicketCategory => ({ name: '', price: 0, capacity: '', description: '', startOffset: 0, startUnit: 'days', startBefore: true, endType: 'untilStart', endOffset: '', endUnit: 'hours', saleUntilEnd: false });

const PresetsModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  // useDashboard throws when no provider exists (public pages). Use try/catch
  // so the modal can be used outside the dashboard context.
  let addNotification: ((msg: string) => void) | undefined;
  try {
    const dash = useDashboard();
    addNotification = dash.addNotification;
  } catch (e) {
    addNotification = undefined;
  }
  const [presets, setPresets] = useState<CategoryPreset[]>(() => loadPresets());

  useEffect(() => {
    try {
      console.log('PresetsModal render:', { isOpen, presetsCount: presets.length });
    } catch (e) {}
  }, [isOpen, presets.length]);

  useEffect(() => {
    if (!isOpen) return;
    try { const arr = loadPresets(); setPresets(arr); } catch (e) {}
  }, [isOpen]);

  const persist = (next: CategoryPreset[]) => { try { savePresets(next); } catch (e) {} };

  const deletePreset = (id: string) => {
    try { deletePresetForAccount(id); } catch (e) {}
    const next = presets.filter(p => p.id !== id);
    setPresets(next);
    persist(next);
  };


  const applyPreset = (id: string) => {
    try {
      const preset = presets.find(p => p.id === id) || null;
      console.log('PresetsModal.applyPreset()', { id, preset });
      if (typeof window !== 'undefined') {
        try { localStorage.setItem('ticketPresetApplyId', id); } catch (e) {}
        try { localStorage.setItem('ticketPresetApply', JSON.stringify(preset)); } catch (e) {}
      }
      // Dispatch a custom event so the current page can apply the preset immediately
      try {
        console.log('PresetsModal dispatching ticketPresetApply', preset);
        try { if (typeof document !== 'undefined') document.dispatchEvent(new CustomEvent('ticketPresetApply', { detail: preset })); } catch (e) { console.error('document dispatch failed', e); }
        try { if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('ticketPresetApply', { detail: preset })); } catch (e) { console.error('window dispatch failed', e); }
      } catch (e) { console.error('dispatch failed', e); }
      // Hinweis entfernt: keine automatische Notification beim Laden einer Vorlage
      onClose();
    } catch (e) { console.error('applyPreset outer failed', e); }
  };

  

  const gradientFor = (seed: string) => {
    const pairs = [
      ['#ff7a7a', '#ffb3b3'],
      ['#7c3aed', '#60a5fa'],
      ['#10b981', '#06b6d4'],
      ['#f59e0b', '#fb7185'],
    ];
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = (h << 5) - h + seed.charCodeAt(i);
    const p = pairs[Math.abs(h) % pairs.length];
    return `linear-gradient(90deg, ${p[0]}, ${p[1]})`;
  };

  return (
    <Modal isOpen={isOpen} onClose={() => { onClose(); }} title="Template laden" disableBodyScroll={true} size="lg">
      <div className="space-y-3">
        <div className="space-y-3">
          {/* Header is rendered by Modal via title prop */}

          <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-2">
            {presets.length === 0 ? (
              <div className="text-gray-400">Keine Presets vorhanden.</div>
            ) : presets.map(p => (
              <div key={p.id} className="p-6 rounded-2xl bg-white/5 border border-white/5 flex items-start justify-between">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-white/5 flex items-center justify-center text-blue-400">
                    {p.name?.[0]?.toUpperCase() || 'P'}
                  </div>
                  <div>
                    <div className="text-lg font-bold text-white">{p.name}</div>
                    <div className="text-sm text-gray-400 mt-1">{p.cats.length} Kategorien</div>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {p.cats.slice(0, 6).map((c, idx) => (
                        <span key={idx} className="text-xs px-2 py-1 rounded-full bg-white/5 text-white">{c.name}</span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-3">
                  <button title="Template in dieses Event laden" onClick={() => applyPreset(p.id)} className="px-4 py-2 bg-white text-black rounded-xl">Hinzufügen</button>
                  <button title="Vorlage löschen" onClick={() => deletePreset(p.id)} className="px-3 py-2 bg-white text-red-600 rounded-xl border border-white/10">Löschen</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
    </Modal>
  );
};

export default PresetsModal;
